import SiapHuni1 from '../Siap Huni/Albasia.webp'
import SiapHuni2 from '../Siap Huni/One East.webp'
import SiapHuni3 from '../Siap Huni/Nishi.webp'
import SiapHuni4 from '../Siap Huni/Lavesh.webp'


const SiapHuniimages =[
SiapHuni1,SiapHuni2,SiapHuni3,SiapHuni4
]

export default SiapHuniimages;